<template>
    <div class="content">
        <pageTool></pageTool>
        <Header
            :page-title="title"
        ></Header>
<!--        <topNav2-->
<!--            :nav-config="navConfig"-->
<!--            @navClick="navClick"-->
<!--        ></topNav2>-->
<!--        <infoListCard-->
<!--            :list-data="demandList"-->
<!--            @infoListCardClick="handleCardClick0"-->
<!--            @moreClick="handleMoreClick0"-->
<!--        ></infoListCard>-->
<!--        <infoListCard-->
<!--            :list-data="demandList2"-->
<!--            @infoListCardClick="handleCardClick1"-->
<!--            @moreClick="handleMoreClick1"-->
<!--        ></infoListCard>-->
        <div class="page-content cus-content">
<!--            <div class="li-header">技术信息 <span>更多<DoubleRightOutlined /></span></div>-->
            <div class="li-header">技术服务</div>
            <div class="li-list" v-if="rtData.listData.length > 0">
                <div class="li-list-row" v-for="(item, i) in rtData.listData" :key="i">
                    <div class="li-list-row-dodd"></div>
                    <div class="li-list-row-content" @click="handleClick(item.id)">
                        <div>{{ item.title }}</div>
                        <div>{{ item.createTime.split(' ')[0] }}</div>
                    </div>
                </div>
            </div>
        </div>
<!--        <div class="fixed-btn" @click="toTec"><img src="../../../assets/img/icon2.png"></div>-->
    </div>
</template>

<script>
import Header from "@/components/SNInfo/Header"
// import infoListCard from "@/components/card/infoListCard"
import {onMounted, reactive} from "@vue/runtime-dom"
import pageTool from "@/components/nav/pageTool"
const banner = require('@/assets/img/page_banner_1.png')
const icon3 = require('@/assets/img/icon3.png')
const icon1 = require('@/assets/img/icon1.png')
const icon2 = require('@/assets/img/icon2.png')
// import { getTrustListApi } from '@/api/trust'
// import { getOrderListApi } from '@/api/order'
import {getPriceCompanyType} from "@/api/demand"
import {useRouter} from "vue-router";
import {getPolicyList} from "@/api/policy";
export default {
    name: "ProductionService",
    setup() {
        const router = useRouter()
        const title = {
            cn: '技术服务',
            en: 'TECHNICAL SERVICES',
            hasSearch: true,
            titleStyle: false,
            banner
        }
        const navConfig = [
            {name: '技术咨询', icon: icon2},
            {name: '托管服务', icon: icon1},
            {name: '订单农业', icon: icon3},
        ]
        // const demandList = reactive({
        //     title: '托管服务',
        //     list: []
        // })
        // const demandList2 = reactive({
        //     title: '订单农业',
        //     list: []
        // })

        const rtData = reactive({
            listData: []
        })
        let priceRes = reactive({})
        const getDomInfo = async () => {
            priceRes = await getPriceCompanyType()
        }
        const getImg = (str) => {
            if (str) {
                return str.split(',')[0]
            }
        }

        const initList = async () => {
            const params = {"current": 1,"model": {"secondCategoryId": 100002}, "size": 200}
            const data = await getPolicyList(params)
            rtData.listData = data.records
        }
        // const initTGData = async (size) => {
        //     const params = {"current": 1,"model": {}, "size": size}
        //     const data = await getTrustListApi(params)
        //     demandList.list = data.records.map(k => ({
        //         id: k.id,
        //         title: k.title,
        //         content: k.price,
        //         size: k.count+priceRes[k.company],
        //         imgs: getImg(k.imgs)
        //     }))
        //     if (size >= 200) {
        //         router.push({ name: 'CardDetailList', query: {data: JSON.stringify(demandList)}})
        //     }
        // }
        // const initDDData = async (size) => {
        //     const params = {"current": 1,"model": {}, "size": size}
        //     const data = await getOrderListApi(params)
        //     demandList2.list = data.records.map(k => ({
        //         id: k.id,
        //         title: k.title,
        //         content: k.price,
        //         size: k.count+priceRes[k.company],
        //         imgs: getImg(k.imgs)
        //     }))
        //     if (size >= 200) {
        //         router.push({ name: 'CardDetailList', query: {data: JSON.stringify(demandList2)}})
        //     }
        // }
        // const handleCardClick0 = (id) => {
        //     router.push({ name: 'ALSDetails', query: {name: '托管服务', id: id}})
        // }
        // const handleCardClick1 = (id) => {
        //     // 订单农业点击
        //     router.push({ name: 'ALSDetails', query: {name: '订单农业', id: id}})
        // }
        // const handleMoreClick0 = () => {
        //     initTGData(200)
        // }
        // const handleMoreClick1 = () => {
        //     // 订单农业点击
        //     initDDData(200)
        // }
        const toTec = () => {
            router.push({ name: 'TechnicalList'})
            // 技术咨询点击
        }
        const handleClick = (id) => {
            // const data = await getPolicyDetail(id)
            // await router.push({name: 'ArticleDetails', query: {id: id, titleCn: title.cn, titleEn: title.en, title: data.title, text: data.text}})
            router.push({ name: 'ArticleDetails', query: { id: id, titleCn: title.cn, titleEn: title.en, type:'1'}})
        }
        // const navClick = (i) => {
        //     console.log(i)
        // }
        onMounted(() => {
            getDomInfo()
            initList()
            // initTGData(3)
            // initDDData(3)
        })
        return {
            title,
            navConfig,
            // navClick,
            // demandList,
            // demandList2,
            rtData,
            priceRes,
            getImg,
            initList,
            // handleCardClick0,
            // handleCardClick1,
            // handleMoreClick0,
            // handleMoreClick1,
            toTec,
            handleClick
        }
    },
    components: {
        Header,
        // topNav2,
        // infoListCard,
        // DoubleRightOutlined,
        pageTool
    }
}
</script>

<style scoped lang="stylus">
    .content {
        background-color #FFF
        .fixed-btn {
            position fixed
            top 85%
            z-index 1
            right 1px
            width 35px
            height 35px
            line-height 30px
            text-align center
            background-color #128BF1
            border-radius 50%
        }
    }

    .page-content {
        padding 20px 30px
    }
</style>